import { render, staticRenderFns } from "./EntryPageSettings.vue?vue&type=template&id=fa688fc0&"
import script from "./EntryPageSettings.vue?vue&type=script&lang=js&"
export * from "./EntryPageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports